import { get } from '../utils/axios';

export const fetchUserDetails = async () => {
  const { data: user } = await get('/user/summary');
  const { data: settings } = await get('/settings');

  return { ...user, ...settings };
};
